import {observer} from 'mobx-react-lite';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import CustomerQuoteFormStore from '../FormStore';

import QuoteVULFields from './QuoteVULFields';
import QuoteRetirementFocusedFields from './QuoteRetirementFocusedFields';
import QuoteBestValueFields from './QuoteBestValueFields';
import QuoteBasicPermanentFields from './QuoteBasicPermanentFields';
import QuoteTemporaryFields from './QuoteTemporaryFields';

const QuoteInputFields = observer(({state}: {state: CustomerQuoteFormStore}) => {
    const errors = state.getQuoteErrors();

    let selectedQuoteFields;
    switch (state.quoteType) {
        case 1:
            selectedQuoteFields = <QuoteVULFields state={state} />;
            break;
        case 2:
            selectedQuoteFields = <QuoteRetirementFocusedFields state={state} />;
            break;
        case 3:
            selectedQuoteFields = <QuoteBestValueFields state={state} />;
            break;
        case 4:
            selectedQuoteFields = <QuoteBasicPermanentFields state={state} />;
            break;
        case 5:
            selectedQuoteFields = <QuoteTemporaryFields state={state} />;
            break;

        default:
            selectedQuoteFields = <div />;
            break;
    }

    return (
        <>
            <FormControl margin="normal" required fullWidth error={errors.blank}>
                <InputLabel>Quote Type</InputLabel>
                <Select
                    defaultValue={0}
                    onChange={({target: {value}}) => {
                        if (typeof value === 'number') {
                            state.setQuoteType(value);
                        }
                    }}
                >
                    <MenuItem value={0}>
                        <em>None</em>
                    </MenuItem>
                    <MenuItem value={1}>VUL</MenuItem>
                    <MenuItem value={2}>Retirement Focused</MenuItem>
                    <MenuItem value={3}>Best Value</MenuItem>
                    <MenuItem value={4}>Basic Permanent</MenuItem>
                    <MenuItem value={5}>Temporary</MenuItem>
                </Select>
                {errors.blank && <FormHelperText>Please add quote details</FormHelperText>}
            </FormControl>

            {selectedQuoteFields}
        </>
    );
});

export default QuoteInputFields;
